import { useQuery } from '@apollo/client';

import type { SearchAlertOrigin } from '@xing-com/crate-common-graphql-types';
import { useLoginState } from '@xing-com/crate-hooks-use-login-state';
import type { GetSearchAlertsQuery } from '@xing-com/crate-jobs-graphql';
import { GetSearchAlertsDocument } from '@xing-com/crate-jobs-graphql';

import type { UseSearchAlertsValue } from './types';

type UseSearchAlertsProps = {
  origin?: SearchAlertOrigin;
};

export const useSearchAlerts = ({
  origin,
}: UseSearchAlertsProps = {}): UseSearchAlertsValue => {
  const { isLoggedIn } = useLoginState();
  const queryResult = useQuery<
    GetSearchAlertsQuery,
    { origin?: SearchAlertOrigin }
  >(GetSearchAlertsDocument, {
    skip: !isLoggedIn,
    errorPolicy: 'all',
    notifyOnNetworkStatusChange: true,
    variables: {
      origin,
    },
  });

  return queryResult;
};
